<template>
  <b-modal ref="deleteResultModal" title="Ergebnis löschen">
    <p class="text-center">
      ACHTUNG! Hiermit wird das Ergebnis unwideruflich gelöscht! Der Schüler oder
      die Schülerin muss sich dann mit dem aktuellen Zugangscode erneut anmelden.
    </p>
    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="send">Bestätigen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'DeleteModal',

  data: function () {
    return {
      token: null
    }
  },

  methods: {
    show: function (token) {
      this.token = token
      this.$refs.deleteResultModal.show()
    },

    hide () {
      this.$refs.deleteResultModal.hide()
    },

    send () {
      this.axios.delete('quiz/results/' + this.token).then(() => {
        this.$emit('deleted', this.token)
        this.$refs.deleteResultModal.hide()
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/results/DeleteResultModal.vue